module.exports = __webpack_public_path__ + "img/icon-tab-1.c73dcc90.svg";